/* ============================================================
   VISTA SUA BOSSA — assets/vista-sua-bossa.js
   ============================================================ */

(function () {
  'use strict';

  // ─── Configuração ─────────────────────────────────────────
  const PAGE_SIZE = 6;       // produtos visíveis inicialmente
  const BATCH_SIZE = 12;     // quantos carregar ao clicar "Ver mais"

  // ─── Estado ───────────────────────────────────────────────
  let allProducts = [];       // todos os produtos carregados da API
  let filtered = [];          // após aplicar filtros
  let visibleCount = PAGE_SIZE;

  // 'todos' | 'bossa' | 'bossinha' | 'colecionaveis' | 'disney-bossinha' | 'disney-bossa'
  let activeType = 'todos';
  let activeColors = new Set();
  let activeCategories = new Set();

  // Coleções por tipo (handles configuráveis via data-attributes na section)
  let collectionHandles = {};

  // ─── Init ─────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('.vsb-catalog');
    if (!root) return;

    collectionHandles = {
      bossa: root.dataset.collectionBossa || 'roupas-bossa-nova',
      bossinha: root.dataset.collectionBossinha || 'roupas-bossinha',
      disney: root.dataset.collectionDisney || 'roupas-disney',
      bossaDisney: root.dataset.collectionBossaDisney || 'roupas-bossa-disney',
      colecionaveis: root.dataset.collectionColecionaveis || 'roupas-colecionaveis',
    };

    bindFilters();
    loadProducts('todos');
    bindLoadMore();
    bindPlayButton();
  });

  // ─── Carregamento ─────────────────────────────────────────
  async function loadProducts(type) {
    showSkeleton();

    let products = [];

    if (type === 'todos') {
      const [bossa, bossaDisney, colecionaveis, bossinha, disney] = await Promise.all([
        fetchCollection(collectionHandles.bossa),
        fetchCollection(collectionHandles.bossaDisney),
        fetchCollection(collectionHandles.colecionaveis),
        fetchCollection(collectionHandles.bossinha),
        fetchCollection(collectionHandles.disney),
      ]);
      bossa.forEach(p => { p._vsb_type = 'bossa'; });
      bossaDisney.forEach(p => { p._vsb_type = 'bossa'; });
      colecionaveis.forEach(p => { p._vsb_type = 'bossa'; });
      bossinha.forEach(p => { p._vsb_type = 'bossinha'; });
      disney.forEach(p => { p._vsb_type = 'disney'; });
      // Deduplica por ID (produto pode estar em mais de uma coleção)
      const seen = new Set();
      products = [...bossa, ...bossaDisney, ...colecionaveis, ...bossinha, ...disney].filter(p => {
        if (seen.has(p.id)) return false;
        seen.add(p.id);
        return true;
      });
    } else if (type === 'disney-bossa') {
      // Bossa Disney: coleção própria (roupas-bossa-disney)
      products = await fetchCollection(collectionHandles.bossaDisney);
      products.forEach(p => { p._vsb_type = 'bossa'; });
    } else if (type === 'disney-bossinha') {
      // Bossinha Disney: coleção Disney, sem os itens que são da Bossa Disney
      const [disney, bossaDisney] = await Promise.all([
        fetchCollection(collectionHandles.disney),
        fetchCollection(collectionHandles.bossaDisney),
      ]);
      const bossaIds = new Set(bossaDisney.map(p => p.id));
      products = disney.filter(p => !bossaIds.has(p.id));
      products.forEach(p => { p._vsb_type = 'bossinha'; });
    } else if (type === 'colecionaveis') {
      products = await fetchCollection(collectionHandles.colecionaveis);
      products.forEach(p => { p._vsb_type = 'bossa'; });
    } else {
      const handle = collectionHandles[type];
      products = await fetchCollection(handle);
      products.forEach(p => { p._vsb_type = type; });
    }

    // Evita que um clique antigo sobrescreva o filtro atual
    if (type !== activeType) return;

    allProducts = products;
    applyFilters();
  }

  // Cache por coleção: troca de aba sem refazer requisições.
  // Retorna cópias rasas para que _vsb_type de uma aba não vaze para outra.
  const collectionCache = {};

  async function fetchCollection(handle) {
    if (!collectionCache[handle]) {
      const url = `/collections/${handle}/products.json?limit=250`;
      collectionCache[handle] = fetch(url)
        .then(resp => (resp.ok ? resp.json() : { products: [] }))
        .then(data => data.products || [])
        .catch(() => {
          delete collectionCache[handle];
          return [];
        });
    }
    const products = await collectionCache[handle];
    return products.map(p => ({ ...p }));
  }

  // ─── Filtros ──────────────────────────────────────────────
  function bindFilters() {
    // Tipo
    document.querySelectorAll('.vsb-type-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.vsb-type-btn').forEach(b => b.classList.remove('vsb-active'));
        this.classList.add('vsb-active');
        activeType = this.dataset.type;
        activeColors.clear();
        activeCategories.clear();
        syncFilterUI();
        visibleCount = PAGE_SIZE;
        loadProducts(activeType);
      });
    });

    // Cor
    document.querySelectorAll('.vsb-filter-item[data-color]').forEach(item => {
      item.addEventListener('click', function () {
        const val = this.dataset.color;
        toggleSet(activeColors, val);
        this.classList.toggle('vsb-active', activeColors.has(val));
        visibleCount = PAGE_SIZE;
        applyFilters();
      });
    });

    // Categoria
    document.querySelectorAll('.vsb-filter-item[data-category]').forEach(item => {
      item.addEventListener('click', function () {
        const val = this.dataset.category;
        toggleSet(activeCategories, val);
        this.classList.toggle('vsb-active', activeCategories.has(val));
        visibleCount = PAGE_SIZE;
        applyFilters();
      });
    });
  }

  function syncFilterUI() {
    document.querySelectorAll('.vsb-filter-item[data-color]').forEach(el => {
      el.classList.toggle('vsb-active', activeColors.has(el.dataset.color));
    });
    document.querySelectorAll('.vsb-filter-item[data-category]').forEach(el => {
      el.classList.toggle('vsb-active', activeCategories.has(el.dataset.category));
    });
  }

  function toggleSet(set, val) {
    if (set.has(val)) set.delete(val);
    else set.add(val);
  }

  function normalizarTags(product) {
    const t = product.tags;
    if (Array.isArray(t)) return t;
    if (typeof t === 'string' && t.length > 0) return t.split(',').map(s => s.trim());
    return [];
  }

  function applyFilters() {
    filtered = allProducts.filter(p => {
      const tags = normalizarTags(p);

      // Filtro de cor
      if (activeColors.size > 0) {
        const hasCor = [...activeColors].some(cor => tags.includes('cor-' + cor));
        if (!hasCor) return false;
      }

      // Filtro de categoria
      if (activeCategories.size > 0) {
        const hasCat = [...activeCategories].some(cat => tags.includes('categoria-' + cat));
        if (!hasCat) return false;
      }

      return true;
    });

    renderGrid();
  }

  // ─── Renderização ─────────────────────────────────────────
  function renderGrid() {
    const grid = document.querySelector('.vsb-grid');
    const countEl = document.querySelector('.vsb-grid-count');
    const loadMoreBtn = document.querySelector('.vsb-load-more-btn');
    if (!grid) return;

    grid.innerHTML = '';

    if (filtered.length === 0) {
      grid.innerHTML = '<div class="vsb-empty">Nenhuma roupa encontrada para os filtros selecionados.</div>';
      if (countEl) countEl.textContent = '';
      if (loadMoreBtn) loadMoreBtn.disabled = true;
      return;
    }

    const toShow = filtered.slice(0, visibleCount);
    toShow.forEach(p => {
      grid.appendChild(buildCard(p));
    });

    if (countEl) {
      countEl.textContent = `Mostrando ${toShow.length} de ${filtered.length} roupas`;
    }

    if (loadMoreBtn) {
      loadMoreBtn.disabled = visibleCount >= filtered.length;
    }
  }

  function showSkeleton() {
    const grid = document.querySelector('.vsb-grid');
    if (!grid) return;
    grid.innerHTML = '';
    for (let i = 0; i < PAGE_SIZE; i++) {
      const sk = document.createElement('div');
      sk.className = 'vsb-card';
      sk.innerHTML = `
        <div style="aspect-ratio:1/1;background:#e0dbd4;animation:vsb-pulse 1.4s ease-in-out infinite;"></div>
        <div class="vsb-card__body">
          <div style="height:14px;background:#e0dbd4;border-radius:2px;width:60%;animation:vsb-pulse 1.4s ease-in-out infinite;"></div>
          <div style="height:12px;background:#e0dbd4;border-radius:2px;width:85%;margin-top:8px;animation:vsb-pulse 1.4s ease-in-out infinite;"></div>
        </div>`;
      grid.appendChild(sk);
    }
  }

  function buildCard(product) {
    const tags = normalizarTags(product);
    const isMaisVendido = tags.includes('mais-vendido');

    // Compatibilidade (Disney sem tag compativel-* não recebe frase de compatibilidade)
    const hasBossa = tags.includes('compativel-bossa') || product._vsb_type === 'bossa';
    const hasBossinha = tags.includes('compativel-bossinha') || product._vsb_type === 'bossinha';
    let compat = '';
    if (hasBossa && hasBossinha) compat = 'Para a Cadeira Bossa Nova e Bossinha.';
    else if (hasBossa) compat = 'Para a Cadeira Bossa Nova.';
    else if (hasBossinha) compat = 'Para a Bossinha.';

    // Uso
    const usoTags = [];
    if (tags.includes('uso-interno-externo')) {
      usoTags.push({ label: 'Interno e Externo', cls: 'vsb-card__tag--externo' });
    } else if (tags.includes('uso-externo')) {
      usoTags.push({ label: 'Externo', cls: 'vsb-card__tag--externo' });
    } else {
      usoTags.push({ label: 'Interno', cls: 'vsb-card__tag--interno' });
    }

    // Preço
    const variant = product.variants && product.variants[0];
    const priceRaw = variant ? parseFloat(variant.price) : 0;
    const priceFormatted = priceRaw.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    const installment = (priceRaw / 10).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    // Imagens (principal + segunda para hover)
    const img1 = product.images && product.images[0] ? product.images[0].src : '';
    const img2 = product.images && product.images[1] ? product.images[1].src : '';
    const variantId = variant ? String(variant.id) : '';
    const productUrl = '/products/' + product.handle;

    // Card como <a> para ser clicável
    const card = document.createElement('a');
    card.href = productUrl;
    card.className = 'vsb-card';
    card.dataset.productId = product.id;

    card.innerHTML = `
      <div class="vsb-card__img-wrap">
        ${isMaisVendido ? '<span class="vsb-card__badge">Mais vendido</span>' : ''}
        ${img1
          ? `<img class="vsb-card__img-primary" src="${img1}" alt="${product.title}" loading="lazy" width="400" height="400">
             ${img2 ? `<img class="vsb-card__img-hover" src="${img2}" alt="${product.title}" loading="lazy" width="400" height="400">` : ''}`
          : `<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#b0a89e;font-size:12px;font-family:'DM Sans',sans-serif;">${product.title}</div>`
        }
      </div>
      <div class="vsb-card__body">
        <p class="vsb-card__title">${product.title}</p>
        ${compat ? `<p class="vsb-card__compat">${compat}</p>` : ''}
        <div class="vsb-card__tags">
          ${usoTags.map(t => `<span class="vsb-card__tag ${t.cls}">${t.label}</span>`).join('')}
        </div>
        <div class="vsb-card__footer">
          <div class="vsb-card__price-block">
            <span class="vsb-card__price">${priceFormatted}</span>
            <span class="vsb-card__installment">10x de ${installment} sem juros</span>
          </div>
          <button class="vsb-card__add-btn" data-variant-id="${variantId}" data-product-url="${productUrl}">
            + Adicionar
          </button>
        </div>
      </div>`;

    // Bind add to cart — stopPropagation para não navegar ao clicar no botão
    const addBtn = card.querySelector('.vsb-card__add-btn');
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const vid = this.dataset.variantId;
        if (vid) addToCart(parseInt(vid, 10), this);
        else window.location.href = this.dataset.productUrl;
      });
    }

    return card;
  }

  function addToCart(variantId, btn) {
    const orig = btn.innerHTML;
    btn.innerHTML = '...';
    btn.style.opacity = '0.6';
    btn.disabled = true;

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(response => {
        btn.innerHTML = '✓ Adicionado';
        btn.style.color = '#2F8551';

        const sectionHtml = response.sections && response.sections['cart-drawer'];
        if (sectionHtml) {
          // Substitui o elemento cart-drawer inteiro — o connectedCallback
          // do Web Component re-executa e registra os listeners corretamente
          const temp = document.createElement('div');
          temp.innerHTML = sectionHtml;
          const newCartDrawer = temp.querySelector('cart-drawer');
          const curCartDrawer = document.querySelector('cart-drawer');

          if (newCartDrawer && curCartDrawer && curCartDrawer.parentNode) {
            curCartDrawer.parentNode.replaceChild(newCartDrawer, curCartDrawer);
          }

          // Atualiza badge do header
          const newBadge = temp.querySelector('.cart-count-bubble');
          const curBadge = document.querySelector('.cart-count-bubble');
          if (newBadge && curBadge) curBadge.innerHTML = newBadge.innerHTML;

          // Abre o novo drawer após o connectedCallback executar
          setTimeout(() => {
            const freshDrawer = document.querySelector('cart-drawer');
            if (freshDrawer) {
              // Tenta método open() nativo
              if (typeof freshDrawer.open === 'function') {
                freshDrawer.open();
              } else {
                // Fallback: clica no ícone do header
                const cartIcon =
                  document.querySelector('[data-cart-toggle]') ||
                  document.querySelector('[aria-label="Carrinho"]') ||
                  document.querySelector('header a[href="/cart"]') ||
                  document.querySelector('a[href="/cart"]');
                if (cartIcon) cartIcon.click();
              }
            }
          }, 100);
        }

        setTimeout(() => {
          btn.innerHTML = orig;
          btn.style.color = '';
          btn.style.opacity = '';
          btn.disabled = false;
        }, 2000);
      })
      .catch(() => {
        btn.innerHTML = orig;
        btn.style.opacity = '';
        btn.disabled = false;
      });
  }

  // ─── Load More ────────────────────────────────────────────
  function bindLoadMore() {
    const btn = document.querySelector('.vsb-load-more-btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      visibleCount += BATCH_SIZE;
      renderGrid();
    });
  }

  // ─── Play button (vídeo hero) ─────────────────────────────
  function bindPlayButton() {
    const playBtn = document.querySelector('.vsb-hero__play-btn');
    const videoWrap = document.querySelector('.vsb-hero__video-wrap');
    if (!playBtn || !videoWrap) return;

    playBtn.addEventListener('click', function () {
      const video = videoWrap.querySelector('video');
      const iframe = videoWrap.querySelector('iframe');

      if (video) {
        video.play();
        playBtn.style.display = 'none';
      } else if (iframe) {
        const src = iframe.src;
        if (!src.includes('autoplay=1')) {
          iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
        }
        playBtn.style.display = 'none';
      }
    });
  }

  // ─── CSS de animação skeleton (injetado dinamicamente) ────
  const style = document.createElement('style');
  style.textContent = `
    @keyframes vsb-pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
  `;
  document.head.appendChild(style);

})();